import styles from './SearchBar.scss';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { cloneDeep, find } from 'lodash';
import { locationShape, routerShape } from 'react-router';
import { isEmpty,  } from 'lodash';

import QuickMenu from 'common/components/QuickMenu/QuickMenu';

export class SearchBar extends Component {
    createSearchEventHandler(queryStringParameter, value){
        function handler(e) {
            const { router, location } = this.props;
            value = value || e.target.value;
            const newLocation = cloneDeep(location);
            newLocation.query = {
                ...newLocation.query,
                offset: 0,
                [queryStringParameter]: value
            };
            router.push(newLocation);
        }

        return handler.bind(this);
    }

    getHeaders() {
        const {
            location: {
                query: {
                    filter,
                    sort,
                    order,
                    status
                }
            },
            filterOptions=[],
            sortOptions=[],
            sortOrderOptions=[],
            sortTaskStatusOptions=[]
        } = this.props;

        const filterHeader = find(filterOptions, { gqlName: filter }) || filterOptions[0];
        const sortHeader = find(sortOptions, { gqlName: sort }) || sortOptions[0];
        const sortOrderHeader = find(sortOrderOptions, { gqlName: order }) || sortOrderOptions[0];
        const sortTaskStatusHeader = find(sortTaskStatusOptions, { gqlName: status }) || sortTaskStatusOptions[0];

        return {
            filterHeader: filterHeader ? `Show ${filterHeader.displayName}` : '',
            sortHeader: sortHeader ? `Sort ${sortHeader.displayName}` : '',
            sortOrderHeader: sortOrderHeader ? `By ${sortOrderHeader.displayName}` : '',
            sortTaskStatusHeader: sortTaskStatusHeader ? `Show ${sortTaskStatusHeader.displayName} Tasks` : '',
        };
    }

    render() {
        const {
            location: {
                query: {
                    q
                }
            },
            filterOptions=[],
            sortOptions=[],
            sortOrderOptions=[],
            sortTaskStatusOptions=[]
        } = this.props;

        const filters = filterOptions.map((fo, i) => {
            return {
                label: fo.displayName,
                handler: this.createSearchEventHandler('filter', fo.gqlName)
            };
        });

        const sorts = sortOptions.map((so, i) => {
            return {
                label: so.displayName,
                handler: this.createSearchEventHandler('sort', so.gqlName)
            };
        });

        const sortOrders = sortOrderOptions.map((so, i) => {
            return {
                label: so.displayName,
                handler: this.createSearchEventHandler('order', so.gqlName)
            };
        });

        const sortTaskStatus = sortTaskStatusOptions.map((so, i) => {
            return {
                label: so.displayName,
                handler: this.createSearchEventHandler('status', so.gqlName)
            };
        });

        const { filterHeader, sortHeader, sortOrderHeader, sortTaskStatusHeader } = this.getHeaders();

        return (
            <div className={styles.searchBar} data-cy="SearchBar">
                <div className={styles.searchIcon}>
                </div>
                <input className={styles.searchBox}
                    type="text"
                    placeholder={this.props.placeholder}
                    value={q || ''} onChange={this.createSearchEventHandler('q')}
                    data-cy="SearchBar-createSearchEventHandler" />
                <div className={styles.controls}>
                    <QuickActionControlMenu header={filterHeader} options={filters} />
                    <QuickActionControlMenu header={sortTaskStatusHeader} options={sortTaskStatus} />
                    <QuickActionControlMenu header={sortHeader} options={sorts} />
                    <QuickActionControlMenu header={sortOrderHeader} options={sortOrders} />
                </div>
            </div>
        );
    }
}

const QuickActionControlMenu = ({ header, options }) => {
    if (isEmpty(options)) {
        return null;
    }

    return (
        <div className={styles.control} data-cy="SearchBar-QuickActionControlMenu">
            <QuickMenu headerText={header} theme="secondary" options={options} />
        </div>
    );
};

const optionShape = {
    displayName: PropTypes.string.isRequired,
    gqlName: PropTypes.string
};

SearchBar.propTypes = {
    router: routerShape.isRequired,
    location: locationShape.isRequired,
    placeholder: PropTypes.string,
    filterOptions: PropTypes.arrayOf(
        PropTypes.shape(optionShape)
    ),
    sortOptions: PropTypes.arrayOf(
        PropTypes.shape(optionShape)
    ),
    sortOrderOptions: PropTypes.arrayOf(
        PropTypes.shape(optionShape)
    ),
};

export default SearchBar;
